<template>
	<div class="row mx-2">
		<h3>Test Component</h3>
      
		<!-- graph-component :productId="productId" ></graph-component -->
	</div>
</template>
<script>
export default {
	props: [],
	data() {
		return {
         responseData: null,
			labels: [
				"Mercury",
				"Venus",
				"Earth",
				"Mars",
				"Jupiter",
				"Saturn",
				"Uranus",
				"Neptune",
			],
         productId: 2,
			options: {
            title: {
               display: true,
               text: 'Balls'
            },
				responsive: false,
				lineTension: 1,   
				scales: {
					yAxes: [
						{
							ticks: {
								beginAtZero: true,
								padding: 25,
							},
						},
					],
				},
			},
			datasets: [
				// {
				// 	label: "Number of Moons",
				// 	data: [0, 0, 1, 2, 79, 82, 27, 14],
				// 	backgroundColor: "rgba(54,73,93,.5)",
				// 	borderColor: "#36495d",
				// 	borderWidth: 3,
            //    type: "line",
				// },

				{
					label: "Planetary Mass (relative to the Sun x 10^-6)",
               type: "line",
					data: [0.166, 0.081, 0.003, 0.323, 0.792, 0.886, 0.662, 0.514],
					backgroundColor: "rgba(71, 183,132,.5)",
					borderColor: "#47b784",
					borderWidth: 30,
				},
			],
		};
	},
   created() {
      console.log("+++created()");
      const payload = {
         body: "bodyStr",
         subject: "subjectStr",
         senderEmail: "sender@email.com",
         recipientEmail: "recipient@email.com",
         recipientName: "recipientNameString",
         attachments: {asd: 123, stuff: "stuff" },
         mailQueueAddressId: 1
      };

      axios.post("/mail_queue/append", payload).then( r => {
         console.log(r);
         this.responseData = r.data;
         this.responseData.attachments = JSON.parse(this.responseData.attachments);
      });
   }
};
</script>











































<!-- 
   template>
   <b-row>
      <b-col class="col-4"></b-col>
      <b-col id="main-div">
            <div id="row-pagination">
            <coi-pagination
               v-model="pagination"
               :customerOrderCount="customerOrderCount" 
            ></coi-pagination>
            <div class="row">
               <b-textarea v-model="paginationString" disabled />
            </div>
            </div>
            <div id="row-user-query">
               <coi-query 
                  :orderStates="orderStates"
                  :marketAccounts="marketAccounts"
                  :vendors="vendors"
                  :countries="countries"
                  :authorization="authorization"
                  :requestInProgress="false"
                  v-on:update:activeQuery="activeQuery = $event"
               ></coi-query>
            </div>
      </b-col>
      <b-col></b-col>
      </b-row>
   </template>
   <script>
      export default {
         name: 'test-component',
         props: [ ],
         data () {
            return {
               customerOrderCount: 0,
               pagination: { //we guarantee to the child component, that we won't mutate the pagination (from here it should be read-only).i
                     userPageChange: true
                  , currentPage: 1
                  , perPage: 5
                  , totalRows: 0
                  , orderBy: '-'
               }
               , /*const*/ orderStates: {
                  types: {
                     '-1': 'Offen'
                     , '0': 'Neu'
                     , '1': 'Erledigt'
                     , '2': 'Freigegeben'
                     , '3': 'Erstattet'
                     , '4': 'Erstattet & OM'
                  },codes: {
                     STATUS: -2,
                     OPEN: -1,
                     NEW: 0,
                     DONE: 1,
                     WAIT: 2,
                     REFUND: 3,
                     REFUND_OK: 4
                  }
               }
               // const values are only set once during the created or mounted events 
               , /*rt-const*/ marketAccounts: null
               , /*rt-const*/ vendors: null
               , /*rt-const*/ countries: null
               , /*rt-const*/ authorization: null
               , activeQuery: this.newQueryScaffolding() //will be set by COIQuery component, once created.
            }
         },
         watch: {
            pagination: {
               deep: true,
               handler: function(n,o) {
               //  if(_.isEqual(n,o)) {
               //   console.log("n,o seem to be equal: ");
               //   console.log(n,o);
               //    return;
               //  }
                  this.customerOrderCount = null;
                  setTimeout(() => {
                  this.customerOrderCount = Math.floor(999999 * Math.random())
                  }, 1000);
               }
            }
         },
         computed: {
            paginationString: function() { return JSON.stringify(this.pagination); }
         },
         methods: {
            newQueryScaffolding() { //WARNING: if you change this, you need to change it in the other components as well!
               return {
                  limit: 10
               , offset: 0
               , count: null // ~~if count is set, we use limit and offset~~ too opaque, using bool instead
               , orderBy: null
               , orderByAscending: true
               , lastQueryTimestamp: null //is timestamp of last query run, additionally we can add lateron a button "re-run query", this way we can re-run the query if lastQueryTimestamp is greater than some value.
               , selectedDateRange: {
                  type: null
                  , from: null
                  , to: null
               }
               , customerName: null // this is not in customer object because it isn't a reference to a specific table member, it is both firstName and lastName
               , customerAddress: null // member represents all address metadata (street1, street2, zipcode, etc.)
               , customerOrder: {
                  id: null // TODO check if coi.id shouldn't be used instead.
                  , customerOrderItem: {
                     id: null
                     , vendor: { id: null }
                     , customerOrderItemDeliveryAddition: { shippingId: null }
                     , stock: { material: { name: null, ean: null } }
                  }
                  , marketOrderId: null
                  , marketAccountId: null
                  , orderState: null
                  , orderTime: null
                  }
               }
            }
         },

         created() {
            Promise.all([
               axios.get('/marketaccount/all')
            , axios.get('/vendor/all')
            , axios.get('/country/all')
            , axios.get('/user/authorization')
         ]).then( ([ _marketAccount, _vendor, _country, _authorization ]) => {
               this.marketAccounts = _marketAccount.data;
               this.vendors        = _vendor.data;
               this.countries      = _country.data;
               this.authorization  = _authorization.data;
         });
         }
      }      
   </script 
-->
